<template>
	<v-container grid-list-xl>
		<v-layout row wrap>
      <v-tabs slider-color="grey">
        <v-tab class="tab" :key="1" ripple>Spine List</v-tab>
        <v-tab class="tab" :key="2" ripple>Manual List</v-tab>
        <!--<v-tab class="tab" :key="3" ripple>Miscellaneous</v-tab>-->
        <v-tab-item class="pl-4 pr-4 pt-4 pb-4" :key="1">
          <v-container grid-list-xl>
            <v-layout row wrap>
              <v-data-table loading="true" style="width:100% !important;" :headers="headers" :items="parsedInstallations" hide-actions disable-initial-sort class="elevation-1">
                <template slot="items" slot-scope="props">
                  <tr class="sortableRow" id="rows">
                    <td width="50%">{{ props.item.description }}</td>
                    <td width="50%">{{ props.item.code }}</td>
                  </tr>
                </template>
              </v-data-table>
            </v-layout>
          </v-container>
        </v-tab-item>
        <v-tab-item class="pl-4 pr-4 pt-4 pb-4" :key="2">
          <v-container grid-list-xl style="padding-top: 10px !important;">
            <v-layout row wrap>
              <v-btn style="display: block;float: left" @click="fncAddManualInstallation" color="success">Add Manual Installation</v-btn>
              <v-btn style="display: block;float: right" @click="fncSaveManualList" color="success">Save Manual List</v-btn>
              <v-data-table loading="true" style="width:100% !important;" :headers="headersManual" :items="parsedManualInstallations" hide-actions disable-initial-sort class="elevation-1">
                <template slot="items" slot-scope="props">
                  <tr class="sortableRow" id="rows">
                    <td width="45%"><v-text-field label="Description" v-model="props.item.description" single-line solo></v-text-field></td>
                    <td width="45%"><v-text-field label="Code" v-model="props.item.code" single-line solo></v-text-field></td>
                    <td width="10%"><a @click.prevent="fncRemoveIndex(props.index)"><i class="material-icons">delete</i></a></td>
                  </tr>
                </template>
              </v-data-table>
            </v-layout>
          </v-container>
        </v-tab-item>
      </v-tabs>
					<!--<v-container grid-list-xl>
						<v-layout row wrap>
              <v-data-table loading="true" style="width:100% !important;" :headers="headers" :items="parsedInstallations" hide-actions disable-initial-sort class="elevation-1">
                <template slot="items" slot-scope="props">
                  <tr class="sortableRow" id="rows">
                    <td width="50%">{{ props.item.description }}</td>
                    <td width="50%">{{ props.item.code }}</td>
                  </tr>
                </template>
              </v-data-table>
						</v-layout>
					</v-container>-->
			<div class="pl-4 pr-4 pb-4 buttonHolder">
				<div style="float: right">
          <v-btn color="success" class="text-xs-right cancelButton" @click.stop="fncHideModal">Close</v-btn>
					<v-btn color="success" class="text-xs-right" @click.stop="fncRunImport">Import From Spine</v-btn>
				</div>
			</div>
			<v-flex lg12 class="requiredMessage">
				<small><strong>&nbsp;</strong></small>
			</v-flex>
		</v-layout>
	</v-container>
</template>

<script>

	import { mapGetters } from 'vuex';

	export default {
	  name: 'Settings',
	  data () {
			return {
        headers: [
          { text: 'Description', value: 'description', sortable: false, width: '50%'  },
          { text: 'Installation Code', value: 'installation Code', sortable: false, width: '50%'  }
        ],
        headersManual: [
          { text: 'Description', value: 'description', sortable: false, width: '45%'  },
          { text: 'Installation Code', value: 'installation Code', sortable: false, width: '45%'  },
          { text: 'Delete', value: 'delete', sortable: false, width: '10%'  }
        ],
        parsedInstallations: [],
        parsedManualInstallations: [],
			};
		},
		mounted() {
	    this.parsedInstallations = JSON.parse( this.objAuthorize.installations );
	    this.parsedManualInstallations = JSON.parse( this.objAuthorize.manual_installations );

	    if( this.parsedManualInstallations == null ) {
        this.parsedManualInstallations = []
      }
		},
    methods: {
      fncRemoveIndex(index) {
        this.parsedManualInstallations.splice(index, 1)
      },
      fncSaveManualList() {
        if( this.parsedManualInstallations.length == 0 ) {
          var manualList = '';
        } else {
          var manualList = JSON.stringify(this.parsedManualInstallations);
        }

        this.$store.dispatch('fncSaveManualInstallations', manualList);

      },
      fncAddManualInstallation() {
        this.parsedManualInstallations.push({description: '', code: ''});
      },
      fncHideModal() {
        this.$store.commit('hideModal');
      },
      fncRunImport() {
        this.$store.dispatch('fncRunSpinInstallationImport', this.objAuthorize.manufacturer);
      }
		},
		computed: {
		...mapGetters([
			'objAuthorize',
			'userEditSettings',
      'attachmentCategories'
		])
	},
	  }
</script>

<style scoped>
	@import './assets/css/shared.css'
</style>
